<template>
  <nuttrema-layout-cred>

    <template slot="overflow">
      <page-help
         v-if="show.pageHelp"
         file="participants"
        :title="$t('label.help')"
        :anchor="`#${$route.name}`"
        @close="show.pageHelp = false">
      </page-help>
    </template>

    <template slot="content">
      <nuttrema-loader v-if="PersonDetails.fetching"></nuttrema-loader>
      <!-- end ~ isLoading   -->
      <nuttrema-empty-result v-else-if="PersonDetails.error" class="with-logo" icon="fal fa-space-shuttle">
        <template slot="text">
          <h1 v-html="$t('label.error_loading_text')"></h1>
          <h4 v-html="$t('label.error_loading_error_text')"></h4>
        </template>
      </nuttrema-empty-result>
    <!-- end ~ isError -->
    <nuttrema-empty-result v-else-if="PersonDetails.notFound" class="with-logo" predefined-set="not-found"></nuttrema-empty-result>
    <!-- end ~ isNotFound -->
    <router-view v-else></router-view>
    </template>
  </nuttrema-layout-cred>
</template>

<script>
import * as EVENT from 'constants/event';

import PageProps from 'components/mixins/page-props';
import NuttremaLayoutCred from 'components/ui/layout/nuttrema-layout-cred';

import PageHelp from 'components/pages/professional/shared/help/page-help-overlay';

export default {
  name: 'page-person-details-view',
  componentName: 'PagePersonDetailsView',
  mixins: [
    PageProps,
  ],
  props: {
    id: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      show: {
        pageHelp: false,
      },
    };
  },
  components: {
    PageHelp,
    NuttremaLayoutCred,
  },
  computed: {
    PersonDetails() {
      return this.$store.getters.PersonDetails(this.id);
    },
  },
  created() {
    this.$on(EVENT.SHOW_PAGE_HELP, () => {
      this.show.pageHelp = true;
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/shared/page-person-details-view.vue